module.exports = __webpack_public_path__ + "img/logo-dark.2bfc5e2a.png";